import React from 'react';

export const Speakers: React.FC = () => {
  const speakers = [
    {
      name: 'Matthew Oladiran',
      title: 'Data Analyst, Powerlabs',
    },
  ];

  return (
    <>
      <div className="grid gap-8   place-content-center">
        <div className="w-full grid place-content-center">
          <div className="w-full md:max-w-[650px]">
            <h3 className="text-center text-secondary text-6xl font-bold mb-4">WEBINAR SPEAKERS</h3>
            <p className="text-sm text-gray-500">Gain Insights from our brilliant minds</p>
          </div>
        </div>

        <div className="grid grid-cols md:grid-cols gap-6 w-10/12  justify-self-center">
          {speakers.map((speaker, index) => (
            <div className="grid grid-cols gap-6 text-white mr-5" key={index}>
              <div className="w-[170px] md:w-[250px] md:h-[300px] rounded-md border-[#1D2939] border-2 mr-4">
                <img
                  src="/images/matthew.jpg"
                  alt="speaker_image"
                  className=" object-cover w-full h-full"
                />
              </div>
              <div className="flex justify-between text-left items-center w-[170px] md:w-[250px]">
                <div>
                  <p className="font-medium">{speaker.name}</p>
                  <p className="font-light italic text-[#B8CADB]">{speaker.title}</p>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    color="#1570EF"
                    className="h-5 w-5 "
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
